module.exports = __webpack_public_path__ + "media/images/flags/16/Israel-eea563f854f1d26933f1af3a95b59b0c.png";